import { FaLayerGroup } from 'react-icons/fa';
import { IoFilterSharp, IoSearchSharp } from 'react-icons/io5';

const KanbanBoardHeader = () => {
  return (
    <div>
      <div className="mt-4 flex w-full items-center justify-between">
        <div className="mx-1.5 flex items-end">
          <button className="inline-flex items-center justify-center gap-1.5 border border-zinc-700 px-3 py-1  text-base font-semibold">
            <IoFilterSharp size={18} />
            Filter
          </button>
          <button className="inline-flex items-center justify-center gap-1.5 border border-zinc-700 px-3 py-1 text-base font-semibold">
            <FaLayerGroup size={18} />
            Group
          </button>
          <button className="inline-flex items-center justify-center border border-zinc-700 px-3 py-1 font-semibold">
            <IoSearchSharp size={24} className="font-bold text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default KanbanBoardHeader;
